import axios from 'axios';
import config from '@/vue-caas/config/config.js';

const baseURI = config.membershipApiUrl;

const menuStoreModule = {
  // namespaced: false,

  state: {
    menuList: [],
  },
  mutations: {
    SET_STORE_MENU_LIST(state, menuList) {
      menuList === '' ? (state.menuList = []) : (state.menuList = menuList);
    },
  },
  actions: {
    getMenuList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/menu/list`, params);
        // console.log(response.data);
        commit('SET_STORE_MENU_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    getMenuListCommon: async ({ commit }, params) => {
      try {
        const response = await axios.get(`${baseURI}/menu/listCommon`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    menuList: (state) => state.menuList,
  },
};

export default menuStoreModule;
